// extracted by mini-css-extract-plugin
export var bodySections = "_6t-8";
export var gray = "_6t-7";
export var green = "_6t-4";
export var iconContainer = "_6t-9";
export var iconWidgetContainer = "_6t-1";
export var phoneIcon = "_6t-2";
export var red = "_6t-5";
export var statusDot = "_6t-3";
export var widgetContainer = "_6t-0";
export var yellow = "_6t-6";